import React, { useState, Children, useCallback, useEffect } from "react";
import { Alert, Form, Spinner } from "react-bootstrap";

import { Calendar, momentLocalizer } from 'react-big-calendar'

import moment from 'moment'
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useLang } from "../../../../../../language";
import { useForm } from "../../../../../../hooks/useForm";
import { useValidator } from "../../../../../../hooks/useValidator";
import { InputText } from "../../../../../../components/Inputs";
import { getNumberOfDays, getParseDate, isStatusError, isStatusSucess } from "../../../../../../helpers/helpers";
import { cloneDeep } from "lodash";
import { AlquileresServices } from "../services/alquileres.service";
import './index.scss'
import { receiveFecha, receiveFechaFormat2 } from "../../../../../../adapters/helpers";

const localizer = momentLocalizer(moment)
require('moment/locale/ca.js')

export const SeccionFechaCalendario = ({ handleFormInscripcion, formInscripcion = {}, setmessageValid, messageValid }: any) => {

  const Lang = useLang()

  const [events, setEvents] = useState<any>([])

  const lang = {
    ca: {
      week: 'Setmana',
      work_week: 'Setmana de treball',
      day: 'Dia',
      month: 'Mes',
      previous: '<',
      next: '>',
      today: 'Avui',
      agenda: 'El Diari',

      showMore: (total: any) => `+${total} més`,
    }
  }

  const [formDatosGenerales, handleInputDatosGenerales, handleFormDatosGenerales, resetDatosGenerales] = useForm({
    // ...InformacionAdicionalAdapters.GET.receive.schema({}),
    title: Lang('EVENTO'),
  })

  const [valuesValidationEvento, handleValidationEvento, handleResetValidationEvento] = useValidator({
    horainicio: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    horafin: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
  })

  const [startEndDates, setStartEndDates] = useState<any>({});

  const [objFechasData, setObjFechasData] = useState<any>({});

  const [startEndSlot, setStartEndSlot] = useState<any>({
    start: '',
    end: '',
  });

  const getStartAndEndDate = (date: Date) => {

    const firstDay = moment(new Date(date.getFullYear(), date.getMonth(), 1)).format('YYYY-MM-DD');
    const lastDay = moment(new Date(date.getFullYear(), date.getMonth() + 1, 0)).format('YYYY-MM-DD');

    setStartEndDates({
      fechainicio: firstDay,
      fechafin: lastDay,
    })
  };

  const onNavigate = useCallback((date: Date) => {
    getStartAndEndDate(date);
  }, []);


  const ColoredDateCellWrapper = useCallback(({ children, value }: any) => {

    let color = ''

    const diaActual = moment(new Date(value)).format('YYYY-MM-DD')

    if (formDatosGenerales.horainicio === diaActual) {
      color = '#6bebb0'
    }

    // -------- Colorear slot seleccionado

    const startEndSlotTemp = cloneDeep(startEndSlot)

    let slotStart = startEndSlotTemp.start
    let slotEnd = startEndSlotTemp.end

    if (!slotEnd) slotEnd = slotStart

    if ((new Date(value))?.getTime() >= (new Date(slotStart + 'T00:00:00'))?.getTime() &&
      (new Date(value))?.getTime() <= (new Date(slotEnd + 'T00:00:00'))?.getTime()) {
      color = '#b0efbf'
    }

    // -------- Colorear dia festivo

    if (isFeriadoySabadoODomingo(value, startEndDates, objFechasData)) {
      color = '#ffe6e6'
    }

    return React.cloneElement(Children.only(children), {
      style: {
        ...children.style,
        backgroundColor: color,
      },
    })

  }, [startEndDates, formDatosGenerales.horainicio, startEndSlot, objFechasData])


  const isFeriadoySabadoODomingo = (value: any, startEndDates: any, objFechasData: any) => {

    const valueDate = new Date(value)

    const valueDateFormat = moment(new Date(value)).format('YYYY-MM-DD')

    const fechainicio = new Date(startEndDates.fechainicio)
    const fechafin = new Date(startEndDates.fechafin)

    if (fechainicio?.getTime() <= valueDate.getTime() && valueDate.getTime() <= fechafin?.getTime()) {

      if (valueDate.getDay() === 6 || valueDate.getDay() === 0 || (objFechasData[valueDateFormat] && objFechasData[valueDateFormat] !== 'diadecobro')) {

        return true
      }
    }

    return false
  }

  useEffect(() => {

    getStartAndEndDate(new Date());

    setmessageValid({
      status: 0,
        message: ''
    })

  }, [])

  const handleSelectSlot = useCallback(

    ({ start, end, title }: any) => {

      const startinputdate = String(getParseDate(new Date(start)) || '')

      // ------ Si no existen ambas fechas

      if (!startEndSlot.start && !startEndSlot.end) {

        setStartEndSlot({
          ...startEndSlot,
          start: startinputdate,
        })
      }

      // ------ Si existe la primera fecha

      if (startEndSlot.start && !startEndSlot.end) {

        if (startEndSlot.start === startinputdate) {

          setStartEndSlot({
            start: '',
            end: '',
          })

        } else if ((new Date(startEndSlot.start))?.getTime() <= (new Date(start))?.getTime()) {

          setStartEndSlot({
            ...startEndSlot,
            end: startinputdate,
          })

          handleFormInscripcion({
            ...formInscripcion,
            fechadesde: startEndSlot.start,
            fechahasta: startinputdate,
          })

        } else {
          setStartEndSlot({
            start: startinputdate,
            end: ''
          })
        }

      }

      // ------ Si existe la segunda fecha

      if (startEndSlot.start && !startEndSlot.end) {

      }


      // ------ Si existen ambas fechas

      if (startEndSlot.start && startEndSlot.end) {

        setStartEndSlot({
          start: startinputdate,
          end: '',
        })

      }

    },
    [startEndSlot]
  )

  // Consultar disponibilidad

  const [fetchCheckDisponibilidad, fetchCheckDisponibilidadData] = AlquileresServices.GET_CHECK_DISPONIBILIDAD()

  useEffect(() => {

    if (isStatusSucess(fetchCheckDisponibilidadData.status)) {      
     
      setObjFechasData(fetchCheckDisponibilidadData.data?.data)
    }

  }, [fetchCheckDisponibilidadData]);
  

  const [fetchCheckDisponibilidadClick, fetchCheckDisponibilidadClickData] = AlquileresServices.GET_CHECK_DISPONIBILIDAD()

  useEffect(() => {

    if (startEndDates.fechainicio && startEndDates.fechafin) {

      fetchCheckDisponibilidad({
        params: {
          fechadesde: startEndDates.fechainicio,
          fechahasta: startEndDates.fechafin,
          idproducto: formInscripcion?.idproducto,
          estricto: false,
        }
      })
    }

  }, [startEndDates.fechainicio, startEndDates.fechafin]);

  
  useEffect(() => {

    if (startEndSlot.start && startEndSlot.end) {

      fetchCheckDisponibilidadClick({
        params: {
          fechadesde: startEndSlot.start,
          fechahasta: startEndSlot.end,
          idproducto: formInscripcion?.idproducto,
          estricto: true,
        }
      })
    }

  }, [startEndSlot.start, startEndSlot.end]);


  useEffect(() => {

    if (isStatusSucess(fetchCheckDisponibilidadClickData.status)) {

      setmessageValid({
        status: 200,
        message: 'Les dates seleccionades són correctes',
      })
    }

    if (isStatusError(fetchCheckDisponibilidadClickData.status)) {

      setmessageValid({
        status: 400,
        message: fetchCheckDisponibilidadClickData?.error?.message,
      })
    }

  }, [fetchCheckDisponibilidadClickData]);

  return (
    <>

      <div className="col-12 mb-4">
        <Alert variant='info' className='my-0 py-2'>
          Feu clic sobre un dia per seleccionar el dia d'inici, feu un segon clic per seleccionar el dia final
        </Alert>
      </div>


      <div className="col-12">

        <section className="position-relative">
          <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 400 }}
            // onSelectEvent={handleSelectEvent}
            onSelectSlot={handleSelectSlot}
            culture='ca'
            messages={lang['ca']}
            views={
              {
                month: true
              }
            }
            selectable
            components={{
              dateCellWrapper: ColoredDateCellWrapper
            }}
            onNavigate={onNavigate}

          />
          {
            fetchCheckDisponibilidadData.loading &&
            <div className="d-flex py-5 justify-content-center align-items-center OverlayCalendar__Loading">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          }
        </section>
      </div>

      <div className="text-center">
        {
          fetchCheckDisponibilidadClickData.loading ?
            <div className="pt-4">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
            :
            <>
              {
                messageValid.message ?
                  <div className="col-12 mt-4">
                    <Alert variant={messageValid?.status === 200 ? 'success' : 'danger'} className='my-0 py-2 text-center'>
                      {messageValid?.message}: {receiveFechaFormat2(receiveFecha(formInscripcion.fechadesde))} - {receiveFechaFormat2(receiveFecha(formInscripcion.fechahasta))}
                    </Alert>
                  </div>
                  :
                  <></>
              }
            </>
        }
      </div>

    </>
  )
};
